var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eg-radio-checkbox-input',_vm._g(_vm._b({attrs:{"type":"checkbox"},scopedSlots:_vm._u([(_vm.$slots['content'] || _vm.$scopedSlots['content'])?{key:"content",fn:function(slotProps){return [_vm._t("content",null,null,slotProps)]}}:null],null,true)},'eg-radio-checkbox-input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }